import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_4 = { class: "s20 px-4" }
const _hoisted_5 = { class: "form-field-floating lg reactive my-4" }
const _hoisted_6 = { class: "grid6 grid-row-gap-0 px-4 my-1" }
const _hoisted_7 = ["id", "onUpdate:modelValue", "readonly"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "s6_mobile px-4 mt-4 flex" }

import { useToastStore } from '@/stores/toast.store';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import { ref, inject, Ref, onMounted, reactive } from 'vue';
    import { useRoute } from 'vue-router';
    import { AMOUNT_FORMAT_CONFIG } from '@/utils';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementProfilFinancier',
  setup(__props) {

    const route = useRoute();
    const toastStore = useToastStore();
    const loading = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const profil = reactive({
        taux_interet: 0,
        indexes: Array.from({ length: 12 }, (_, index) => 0)
    });

    onMounted(() => {
        const dbProfil: any = (route.meta.item as any).profil;
        if (dbProfil) {
            Object.assign(profil, {
                taux_interet: dbProfil.taux_interet,
                indexes: dbProfil.index ?? profil.indexes
            });
        }
    })

    async function onSubmit() {
        try {
            loading.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/save_profilfinancier`, profil);
            toastStore.success("Profil enregistré");
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"s10_mobile container-full-2\"><h2 class=\"flex align-items-center gap-4 font-medium text-primary-color my-5\"><img src=\"/public/icons/icon-info-perso.svg\" class=\"size-l\" alt=\"\"> Profil Financier </h2></div><div class=\"s10 mt--5-5 flex-right gap-3\"></div><div class=\"clear-both h-5\"></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_money3, _mergeProps({
              class: "form-input",
              modelValue: profil.taux_interet,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profil.taux_interet) = $event)),
              name: "profil.taux_interet",
              id: "profil.taux_interet",
              placeholder: ""
            }, _unref(AMOUNT_FORMAT_CONFIG), {
              readonly: _unref(collectivite)?.verrouille
            }), null, 16, ["modelValue", "readonly"]),
            _cache[1] || (_cache[1] = _createElementVNode("label", { for: "taux_interet" }, [
              _createTextVNode("Taux Interets Microfinance "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profil.indexes, (indexEl, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "form-field-floating lg reactive my-4",
              key: 'index_' + (i + 1)
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-input",
                name: "index[]",
                id: 'index_' + (i + 1),
                placeholder: "",
                "onUpdate:modelValue": ($event: any) => ((profil.indexes[i]) = $event),
                readonly: _unref(collectivite)?.verrouille
              }, null, 8, _hoisted_7), [
                [_vModelText, profil.indexes[i]]
              ]),
              _createElementVNode("label", {
                for: 'index_' + (i + 1)
              }, [
                _createTextVNode("Index " + _toDisplayString(i + 1) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("b", { class: "color-danger" }, "*", -1))
              ], 8, _hoisted_8)
            ]))
          }), 128))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "s14_mobile px-4 flex" }, "   ", -1)),
        _createElementVNode("div", _hoisted_9, [
          (!_unref(collectivite)?.verrouille)
            ? (_openBlock(), _createBlock(_component_custom_button, {
                key: 0,
                classesList: 'btn-ultra lg w-100 shadow-0',
                onClick: onSubmit
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-valider.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Valider", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both" }, null, -1))
    ])
  ]))
}
}

})